export const AdFilter = {
  4: [
    { id: "ScreenHealthReport", text: "건강분석리포트 스크린" },
    { id: "ScreenShopping", text: "쇼핑 탭" },
    { id: "TabGutN", text: "미생물검사 탭" },
    { id: "TabEpidemic", text: "유행주의보 탭" },
  ],
  5: [{ id: "ScreenAlarm", text: "알림센터 스크린" }],
  9: [
    { id: "ScreenInputSymptom", text: "증상 입력 스크린" },
    { id: "ScreenInputHospital", text: "병원 입력 스크린" },
    { id: "ScreenKidProfile", text: "아이 프로필 스크린" },
  ],
};

const _adUserList = [
  { id: "ALL", text: "전체유저" },
  { id: "NORMAL", text: "일반유저" },
  { id: "MEMBERSHIP", text: "멤버십유저" },
];

export const AdUser = {
  4: _adUserList,
  5: _adUserList,
  9: _adUserList,
};

const _openTypeList = [
  { id: "W", text: "웹뷰" },
  { id: "B", text: "브라우저" },
  { id: "S", text: "스크린" },
  { id: "N", text: "수동처리" },
];

const _openTypeListWithHome = [
  { id: "W", text: "웹뷰" },
  { id: "B", text: "브라우저" },
  { id: "S", text: "스크린" },
  { id: "H", text: "홈" },
  { id: "N", text: "수동처리" },
];

export const HomeType = [
  { id: "store", text: "스토어" },
  { id: "community_board", text: "커뮤니티 게시판" },
  { id: "community_post", text: "커뮤니티 게시글" },
];

export const OpenType = {
  1: _openTypeListWithHome,
  2: _openTypeListWithHome,
  3: _openTypeListWithHome,
  4: _openTypeListWithHome,
  5: _openTypeListWithHome,
  9: _openTypeListWithHome,
  10: _openTypeListWithHome,
  13: _openTypeListWithHome,
  14: _openTypeListWithHome,
  15: _openTypeListWithHome,
};

export const OpenTypeLeft = {
  7: _openTypeListWithHome,
  8: _openTypeListWithHome,
};

export const BannerBaseData = {
  img_url: "",
  img_name: "",
  link_url: "",
  link_url_i: "",
  open_type: "B",
};

export const SymptomList = [
  { id: "9", text: "심하게 늘어짐" },
  { id: "5", text: "숨쉬기 힘들어 함" },
  { id: "7", text: "쌕쌕거림" },
  { id: "36", text: "입술/손발 청색증" },
  { id: "37", text: "산소포화도 낮음" },
  { id: "27", text: "경련" },
  { id: "47", text: "오한" },
  { id: "54", text: "식욕/먹는 양 감소" },
  { id: "22", text: "두통" },
  { id: "42", text: "근육통/관절통" },
  { id: "46", text: "피로감/권태감" },
  { id: "10", text: "심한 짜증/보챔" },
  { id: "50", text: "맑은/흰 콧물" },
  { id: "51", text: "노란/초록 콧물" },
  { id: "43", text: "코막힘" },
  { id: "34", text: "목 아픔" },
  { id: "29", text: "귀 아픔" },
  { id: "3", text: "후비루/가래" },
  { id: "53", text: "마른 기침" },
  { id: "52", text: "가래 기침" },
  { id: "6", text: "컹컹대는 기침" },
  { id: "18", text: "복통" },
  { id: "39", text: "메스꺼움" },
  { id: "15", text: "구토" },
  { id: "16", text: "무른변/설사" },
  { id: "38", text: "혈변" },
  { id: "31", text: "얼굴 발진" },
  { id: "19", text: "몸통 발진" },
  { id: "20", text: "손발 수포" },
  { id: "48", text: "팔다리 발진" },
  { id: "40", text: "접종부위 붉어짐" },
  { id: "21", text: "입술/구강 수포" },
  { id: "44", text: "눈 충혈" },
  { id: "49", text: "눈꼽" },
  { id: "23", text: "황달" },
];

export const DiseaseList = [
  { id: "7", text: "열감기" },
  { id: "6", text: "인두염/편도염" },
  { id: "1", text: "기관지염" },
  { id: "2", text: "(모)세기관지염" },
  { id: "3", text: "폐렴" },
  { id: "8", text: "독감(인플루엔자)" },
  { id: "30", text: "코로나19" },
  { id: "15", text: "중이염" },
  { id: "24", text: "부비동염/축농증" },
  { id: "10", text: "구내염(헤르판지나)" },
  { id: "31", text: "인후염/후두염" },
  { id: "32", text: "크룹" },
  { id: "27", text: "백일해" },
  { id: "33", text: "천식" },
  { id: "34", text: "장염" },
  { id: "35", text: "식중독" },
  { id: "36", text: "충수염" },
  { id: "37", text: "게실염" },
  { id: "12", text: "수족구병" },
  { id: "21", text: "돌발진" },
  { id: "26", text: "단순포진(헤르페스)" },
  { id: "18", text: "성홍열" },
  { id: "19", text: "수두" },
  { id: "17", text: "볼거리" },
  { id: "20", text: "홍역" },
  { id: "38", text: "풍진" },
  { id: "16", text: "요로감염" },
  { id: "14", text: "뇌수막염" },
  { id: "39", text: "뇌염" },
  { id: "40", text: "파파증후군" },
  { id: "28", text: "가와사키 병" },
  { id: "23", text: "진단 미확정/기타" },
];
